<template>
  <div>
    <div class="admin_title">直播管理</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input @click="searchByFilter()" type="button" class="btn_s_gj" /><input name="" type="text" class="put_gj" v-model="filter.name" @keyup.13="searchByFilter()"/>
      <select name="visibleRange" class="selcet_put" v-model="filter.visibleRange" @change="searchByFilter()">
        <option value="">全部(推送范围)</option>
        <option v-for='item in Dropdown.state.visibleRangeType' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="state" class="selcet_put" v-model="filter.state" @change="searchByFilter()">
        <option value="">全部(直播状态)</option>
        <option v-for='item in Dropdown.state.putOnOffType' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="timeState" class="selcet_put" v-model="filter.timeState" @change="searchByFilter()">
        <option value="">全部(时间状态)</option>
        <option v-for='item in Dropdown.state.timeState' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <a @click="editLivePlay('')" class="btn btn_add">新增直播</a>
    </div>
    <div class="class_list">
      <dl v-for="item in list" :key="item.id">
        <dt>
          <!--<i class='input_style checkbox_bg'><input type="checkbox" value="1"></i>-->
          <img v-if="!item.cover || item.cover===''" src="@/assets/images/live_img.jpg" />
          <img v-if="item.cover && item.cover!==''" :src="item.cover"  />
        </dt>
        <dd>
          <h3>{{item.name}}</h3>
          <p>状态：{{item.timeStateName}}<a href="javascript:;" @click="getLivePlayPath(item.id, item.appName)" class="marginL8">查看</a><a href="javascript:;" @click="editLivePlay(item.id)">编辑</a></p>
        </dd>
      </dl>
      <h5 class="none_ts" v-if="livePlayCnt <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{livePlayCnt}}个直播课程</dt>
        <dd v-if="livePlayCnt > 0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
    <!--直播地址弹出-->
    <div class="tan livePath" style="display:none;">
      <div class="px_add_con" style="height:500px;">
        <div class="h370 rdiv" style="height:420px;">
          <h3>直播地址列表</h3>
          <a  href="javascript:void(0);"  class="close" @click="$utils.fadeOut('.livePath')" ></a>
          <div class="h200" style="overflow-x:hidden;height:350px;">
            <ul class="liveUL">
              <li class="title">推流地址:</li>
              <li>{{rtmpUrlStr}}</li>
              <li class="title">直播地址:</li>
              <li>{{playUrlArr[0]}}</li>
              <li>{{playUrlArr[1]}}</li>
              <li>{{playUrlArr[2]}}</li>
            </ul>
          </div>
        </div>
        <div class="clear"></div>
        <div class="w240 wrap mt30" style="text-align: center">
          <input name="" type="button" value="确定" class="all_btn" @click="$utils.fadeOut('.livePath')" />
        </div>
      </div>
    </div>
    <!--/直播地址弹出-->
  </div>
</template>
<script>

import Dropdown from '@/store/modules/dropdowns'
import {init} from '@/assets/js/public'
import Paginate from 'vuejs-paginate'
import Ueditor from '@/components/common/UE/ue'
export default {
  components: { Paginate },
  data () {
    return {
      Dropdown: Dropdown,
      filter: {
        pageNo: 1,
        pageSize: this.$global.paginationOptions.page_num,
        visibleRange: '',
        state: '',
        timeState: ''
      },
      list: [],
      rtmpUrlStr: '',
      playUrlArr: [],
      pages: 0,
      livePlayCnt: 0,
      prefix: this.$route.meta.prefix || ''
    }
  },
  created () {
    this.getLivePlays(this.filter)
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  computed: {
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getLivePlays(this.filter)
    },
    searchByFilter () {
      this.getLivePlays(this.filter)
    },
    getLivePlays (filter) {
      this.$api.post(this.$global.livePlayApiPath, 'livePlayInfo/findList', filter, r => {
        this.livePlayCnt = r.cntData
        this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
        this.list = r.data
      })
    },
    editLivePlay (id) {
      if (id == '') {
        id = 'create'
      }
      this.$router.push({path: this.prefix + '/org/livePlay/'+ id})
    },
    getLivePlayPath (id, appName) {
      this.$api.get(this.$global.livePlayApiPath, 'livePlayInfo/getRtmpUrl', {appName: appName, streamName: id}, r => {
        this.rtmpUrlStr = r.data
        this.$api.get(this.$global.livePlayApiPath, 'livePlayInfo/getPlayUrl', {appName: appName, streamName: id}, r => {
          this.playUrlArr = r.data
          this.$utils.fadeIn('.livePath')
        })
      })
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/livePlay/list.vue